export enum StateModeEnum {
  View = 'view',
  Create = 'create',
  Edit = 'edit',
}

export enum PageName {
  AllProducts = 'allProducts',
  Departments = 'departments',
  ProductSearch = 'productSearch',
}

export enum AppLanguage {
  English = 'en',
  Ukrainian = 'uk',
}

export enum EntityType {
  Product = 'product',
  Category = 'category',
}

export enum TaskTypeEnum {
  Workflow = 'workflow',
  Additional = 'additional',
}

export enum WebsocketEvent {
  LaunchFinished = 'pw_launch_finished',
  LaunchFailed = 'pw_launch_failed',
  BulkTaskAssignmentFinished = 'task_assignment_finished',
  BulkTaskUnAssignmentFinished = 'task_unassignment_finished',
  BulkTaskAssignmentFailed = 'task_assignment_failed',
  BulkTaskUnAssignmentFailed = 'task_unassignment_failed',
  BulkStatusChangeTaskUpdateFinished = 'bulk_status_change_task_update_finished',
  BulkStatusChangeTaskUpdateFailed = 'bulk_status_change_task_update_failed',
  BulkStatusChangeStarted = 'bulk_status_change_started',
  BulkStatusChangeFinished = 'bulk_status_change_finished',
  TaskAutoAssignmentFinished = 'auto_assignment_finished',
}

export enum LocationTheProductionStatusIsChangingFrom {
  WorkflowItem = 'workflow_item',
  WorkflowHeader = 'workflow_header',
  ProductionList = 'production_list',
  NewProductionModal = 'new_production_modal',
  WorkflowItemAdditionalProduction = 'workflows_item_additional_production',
}
